export const STORAGE_KEYS = {
  permissions: 'permissions',
  loginType: 'loginType'
};

export function buildPermissionMap(raw) {
  const map = {};
  (raw ?? []).forEach((p) => {
    map[p.module] = map[p.module] || {};
    (p.actions || []).forEach((a) => {
      map[p.module][a] = true;
    });
  });
  return map;
}

export function canDo(loginType, pm, moduleName, action) {
  if (!loginType) return false;

  const lt = String(loginType).toUpperCase();
  if (lt === 'SUPER_ADMIN' || lt === 'ADMIN') return true;

  return !!pm?.[moduleName]?.[action];
}

export const canSeeModule = (loginType, pm, moduleName) =>
  canDo(loginType, pm, moduleName, 'List');
